import React from 'react'
import { compose } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import withStyles from '@material-ui/core/styles/withStyles'
import { useIntl } from 'react-intl'
import { getStyles } from 'isotope-client'
import Grid from '@material-ui/core/Grid'
import SectionIcon from '@material-ui/icons/Assessment'
import Typography from '@material-ui/core/Typography'
import { getUserLanguage } from '../../../fo/user/services/userSelectors'
import { DEFAULT_LANGUAGE_ID } from '../../../../utils/constants'

const styles = theme => getStyles({
	container: {
		border: '1px solid #c8dcdc',
		borderRadius: 5,
		padding: 5,
		marginBottom: 15,
		cursor: 'pointer'
	},
	iconPublished: {
		color: theme.palette.secondary.main
	},
	iconNotPublished: {
		color: theme.palette.draft
	}
})

/**
 * Affichage d'une tuile section
 */
const SectionResearchBloc = ({
	section,
	handleSelectSection,
	classes,
	idLanguage
}) => {
	const intl = useIntl()
	const dataSection = section.dataResearchSection.find(data => data.idLanguage === parseInt(idLanguage)) || section.dataResearchSection.find(data => data.idLanguage === parseInt(DEFAULT_LANGUAGE_ID))
	const sectionTitle = dataSection.label

	return (
		<Grid item container className={classes.container} onClick={() => handleSelectSection({ ...section })} alignItems="center">
			<Grid item xs={1}>
				<SectionIcon fontSize="large" className={section.researchSection.published ? classes.iconPublished : classes.iconNotPublished} />
			</Grid>
			<Grid item xs={11} container direction="column">
				<Typography variant="h6">{sectionTitle || intl.formatMessage({ id: 'parametrage.section.defaultTitle' })}</Typography>
			</Grid>
		</Grid>

	)
}

SectionResearchBloc.propTypes = {
	section: PropTypes.object,
	idLanguage: PropTypes.string,
	handleSelectSection: PropTypes.func,
	classes: PropTypes.object
}

const mapStateToProps = state => ({
	idLanguage: getUserLanguage(state)
})

export default compose(
	connect(mapStateToProps),
	withStyles(styles)
)(SectionResearchBloc)
